// extracted by mini-css-extract-plugin
module.exports = {"menuSideBar":"Sidebar_menuSideBar__3TyKN","menuItem":"Sidebar_menuItem__2cQsk","supportItem":"Sidebar_supportItem__2sQ6O","name":"Sidebar_name__1joYV"};